import { Controller } from 'stimulus';

export default class extends Controller {
  static targets = ['radio', 'input'];

  connect() {
    let checked = this.radioTargets.find(radio => radio.checked);
    this.renderCheck(checked.value);
  }

  change_part(event) {
    this.renderCheck(event.target.value);
  }

  renderCheck(id) {
    this.inputTargets.forEach((input) => {
      input.classList.add('is-hidden');
      input.querySelectorAll('input').forEach(input => input.disabled = true);
    });
    
    let to_select = this.inputTargets.find(input => input.dataset["partId"] == id);
    to_select.classList.remove('is-hidden');
    to_select.querySelectorAll('input').forEach(input => input.disabled = false);
  }
}
